import _mock from "../_mock";

export const _teachers = [...Array(24)].map((_, index) => ({
  id: "id",
  first_name: "f",
  last_name: "l",
  image: "i",
  year_of_birth: "y",
  facebook_url: "f",
  specialization: "s",
  telephone: "t",
  address: "a",
  experiences: "e",
  average_evaluation: "a",
}));
